"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.padNumber = exports.convertSecondsToDisplayTime = exports.calculateRemainingTime = void 0;
const withTimerSecondInterval_1 = __importDefault(require("./withTimerSecondInterval"));
function calculateRemainingTime(endTimestamp) {
    const timestamp = Number(endTimestamp);
    if (isNaN(timestamp)) {
        return { finished: true, remaining: 0 };
    }
    let remaining = Math.floor((timestamp - Date.now()) / 1000);
    let finished = false;
    if (remaining < 0) {
        finished = true;
        remaining = 0;
    }
    return { finished, remaining };
}
exports.calculateRemainingTime = calculateRemainingTime;
function convertSecondsToDisplayTime(remaining) {
    const sec = remaining % 60;
    const min = Math.floor(Number(remaining / 60) % 60);
    const minWithoutHrs = Math.floor(Number(remaining / 60));
    const hrsWithoutDay = Math.floor(Number(remaining / 3600));
    const hrs = hrsWithoutDay % 24;
    const day = Math.floor(Number(remaining / 86400));
    return { day, hrs, hrsWithoutDay, min, minWithoutHrs, sec };
}
exports.convertSecondsToDisplayTime = convertSecondsToDisplayTime;
function padNumber(number) {
    const parsed = number.toString();
    if (parsed.length < 2)
        return `0${parsed}`;
    return parsed;
}
exports.padNumber = padNumber;
exports.default = {
    calculateRemainingTime,
    convertSecondsToDisplayTime,
    padNumber,
    withTimerSecondInterval: withTimerSecondInterval_1.default,
};
